import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Text, Icon, Stack } from '@rebeldotcom/components'
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.object,
      ]).isRequired,
      heading: PropTypes.string.isRequired,
    })
  ).isRequired,
}

const ContentPane = motion.custom(styled.div`
  overflow: hidden;
  background-color: ${({ theme: { colors } }) => colors.white};
  width: 100%;
  border-bottom: ${({ theme: { borders } }) => borders[2]};
`)

const IconBox = motion.custom(styled.div``)

const iconBoxVariants = {
  open: { rotate: 180 },
  closed: { rotate: 0 },
}

const buttonStyles = css`
  ${({ theme: { space } }) => `
    padding: ${space[3]} ${space[4]};
  `}
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: none;
  outline: none;
  width: 100%;
  transition: background-color 0.2s ease;
  background-color: ${({ theme: { colors } }) => colors.greys[8]};
  color: ${({ theme: { colors } }) => colors.black};
  border-bottom: ${({ theme: { borders } }) => borders[2]};

  &:hover,
  &:active {
    background-color: #ccc;
    color: ${({ theme: { colors } }) => colors.black};
  }
`

const itemPropTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  heading: PropTypes.string.isRequired,
}

const AccordionItem = ({ heading, content, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  const paneVariants = {
    visible: { opacity: 1, height: 'auto' },
    hidden: { opacity: 0, height: '0px' },
  }

  return (
    <Stack {...rest}>
      <Button css={buttonStyles} display="flex" onClick={toggleAccordion}>
        <Text textAlign="left" variant="kiloBold">
          {heading}
        </Text>
        <IconBox
          animate={isOpen ? 'open' : 'closed'}
          variants={iconBoxVariants}
        >
          <Icon
            height="3rem"
            ml="auto"
            name="arrow-down"
            title="back"
            width="4rem"
          />
        </IconBox>
      </Button>

      <ContentPane
        animate={isOpen ? 'visible' : 'hidden'}
        overflow="hidden"
        px={3}
        transition={{ opacity: { duration: 0.1 }, height: { duration: 0.2 } }}
        variants={paneVariants}
        width="100%"
      >
        <Stack bg="greys.8" px={4} py={3}>
          {content}
        </Stack>
      </ContentPane>
    </Stack>
  )
}

AccordionItem.propTypes = itemPropTypes

const AccordionPane = ({ items }) => {
  return (
    <Stack as="li">
      {items &&
        items.map(({ heading, content }) => {
          return (
            <AccordionItem key={heading} content={content} heading={heading} />
          )
        })}
    </Stack>
  )
}

AccordionPane.propTypes = propTypes

export { AccordionPane }
